// return revenue centers with at least one selected menus
export const getRevenueCentersWithSelectedMenus = (
  revenueCentersAndMenus = [],
  selectedRevenueCentersAndMenusUuids = []
) => {
  // return revenue centers which contain at least one selected menu
  const revenueCentersWithAtLeastOneSelectedMenu =
    revenueCentersAndMenus?.filter(({ menus }) => {
      return menus?.some(({ uuid }) =>
        selectedRevenueCentersAndMenusUuids?.includes(uuid)
      )
    })

  // return revenue centers with only selected menus
  const revenueCentersWithSelcetedMenus =
    revenueCentersWithAtLeastOneSelectedMenu?.reduce((acc, cur) => {
      // return only seleceted menus per current revenue center
      const selectedMenus = cur?.menus?.filter(({ uuid }) =>
        selectedRevenueCentersAndMenusUuids?.includes(uuid)
      )

      return [...acc, { ...cur, menus: selectedMenus }]
    }, [])

  return revenueCentersWithSelcetedMenus ?? []
}
